import useRest from './useRestClient'
import { format } from 'date-fns'
import useUrls from './useUrls'
import useFCPModel from './useFCPModel'
import { RESTStatus } from '../types/common.js'

/**
 * This composition function exposes functions for working with procedures.
 */
export default function useApi() {
  const { context, loading } = useFCPModel()
  const { get, post } = useRest()
  const { buildApiUrl, buildUrl } = useUrls(context)

  const loadBenefits = async (context) => {
    const url = buildApiUrl('/fcp/csearch/api/benefitDetails', { category: decodeURIComponent(context.category) })
    
    try { 
      loading.value = true
      const result = await post(url.toString(), context)
      if (result.status === 'OK') {
        loading.value = false
        if(result.value) return result.value
        return null
      }
    } catch (error) {
      console.log(error)
      loading.value = false
      throw new Error('Error occurred while trying to retrieve benefits.')
    }
  }


  /**
   * Given a term ( from 'to help me with' field ) return a list of associated specialties
   */
  const loadSpecialties = async (context) => {
    //const url = `/fcp/csearch/api/specialties`
    const url = buildApiUrl('/fcp/csearch/api/specialties')
    const result = await post(url.toString(), context)

    if (result.status === 'OK') {
      return result.value
    }

    throw new Error('Error occurred while trying to retrieve procedures.')
  }

    /**
   * Get list of items for the 'to help me with' field
   */
    const loadToHelpMeWithItems = async (context) => {
      try {
        const result = await post('/fcp/csearch/api/toHelpMeWithItems', context)

        if (result.status === 'Ok') {
          return result
        }
        return null
      } catch (error) {
        console.log(error)
        return null
      }
  }

  /**
   * Given a term ( from 'to help me with' field ) return a list of associated Medical equipments
   */
  const loadMedicalEquipments = async (context) => {
    //const url = `/fcp/csearch/api/specialties`
    const url = buildApiUrl('/fcp/csearch/api/medicalEquipment')
    const result = await post(url.toString(), context)

    if (result.status === 'OK') {
      return result.value
    }

    throw new Error('Error occurred while trying to retrieve medical equipments.')
  }

  /**
   * Given a term ( from 'to help me with' field ) return a list of associated services
   */
   const loadServices = async (context) => {
    const url = buildApiUrl('/fcp/csearch/api/services')
    const result = await post(url.toString(), context)

    if (result.status === 'OK') {
      return result.value
    }

    throw new Error('Error occurred while trying to retrieve services.')
  }

  /**
   * pull the list of Races and Ethnicities from service locator
   */
  const loadRaceEthnicity = async (networkId, context) => {
    const asof = context.asOfDate ? context.asOfDate : format(new Date(), 'yyyy-MM-dd')
    //const url = `/fcp/csearch/api/distinctions/${networkId.value}/${asof}`
    //const url = buildApiUrl(`/fcp/csearch/api/distinctions/${networkId.value}/${asof}`)
    const url = buildUrl('/fcp/csearch/api/distinctions', { networkId: networkId, asOfDate: asof}, false)
    //console.log("Distinctions url", url.toString())

    try {
      const result = await get(url.toString())
      if (result.status === RESTStatus.Ok) {
        return result.value
      }
    } catch (error) {
      console.log(error)
      throw new Error('Error occurred while retreving races and ethnicities.')
    }
  }

  const loadHospitalAffiliations = async (networkId, latitude, longitude, distance, employerGroupId, asOfDate) => {

    const url = buildUrl('/fcp/csearch/api/hospitalAffiliations', { networkId: networkId, lat: latitude, long: longitude, distance: distance, employerGroupId:employerGroupId, asOfDate:asOfDate}, false)
    try {
      const results = await get(url.toString())
      return results.value
    }
    catch(error) {
      console.log(error)
      return []
    }
  }

  const fns = { loadSpecialties, loadRaceEthnicity, loadMedicalEquipments, loadHospitalAffiliations, loadServices, loadBenefits, loadToHelpMeWithItems }

  return fns
}